import React, { useState } from 'react';
import Modal from 'react-modal';
import toast from 'react-hot-toast';
import { Oval } from 'react-loader-spinner';

import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { toggleShowCreateScheduleModal, createSchedule } from '../scheduleSlice';
import { ReactComponent as Close } from '../../../assets/images/close.svg';

import './CreateScheduleModal.scss';

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: "#FFFFFF"
  },
  overlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.8)'
  }
};

export function CreateScheduleModal() {
  const dispatch = useAppDispatch();

  const isOpen = useAppSelector(state => state.schedules.showCreateScheduleModal);
  const drivers = useAppSelector(state => state.driversV2.drivers) || [];
  const vehicles = useAppSelector(state => state.vehicles.vehicles) || [];
  const schedules = useAppSelector(state => state.schedules.schedules) || [];
  const date = useAppSelector(state => state.schedules.dateMoment);
  const createScheduleAPI = useAppSelector(state => state.schedules.createSchedule);

  const [driverId, setDriverId] = useState('');
  const [vehicleId, setVehicleId] = useState('');

  const availableDrivers = drivers.filter(
    driver => !schedules.find(s => s.driverId === driver.userId)
  );

  const availableVehicles = vehicles.filter(
    vehicle => !schedules.find(s => s.vehicleId === vehicle.id)
  );

  React.useEffect(() => {
    if (!createScheduleAPI.loading && !!createScheduleAPI.error) {
      if (createScheduleAPI.error.code === "3004") {
        toast.error('Schedule can\'t be created for date in the past.');
      } else {
        toast.error('Something went wrong. Please try again.');
      }
    }

    if (!createScheduleAPI.loading && !createScheduleAPI.error && createScheduleAPI.value) {
      toast.success('Successfully added schedule.');
      resetForm();
      dispatch(toggleShowCreateScheduleModal());
    }
  }, [!createScheduleAPI.loading, !!createScheduleAPI.error, !!createScheduleAPI.value]);

  const resetForm = () => {
    setDriverId('');
    setVehicleId('');
  };

  const toggleModal = () => {
    resetForm();
    dispatch(toggleShowCreateScheduleModal());
  };

  const onSubmit = () => {
    if (createScheduleAPI.loading || !driverId || !vehicleId) return;

    dispatch(createSchedule({
      driverId,
      vehicleId,
      date
    }));
  };

  const isValid = !!driverId && !!vehicleId;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={toggleModal}
      style={modalStyles}
    >
      <div className='create-schedule-modal-component'>
        <Close className='close-button' onClick={toggleModal}/>

        <div className='title-container'>
          <div className='title'>Create Schedule</div>
          {createScheduleAPI.loading && <Oval color="#131313" height={20} width={20} secondaryColor="#FBD20A"/>}
        </div>

        <div className='form'>
          <div className='form-group'>
            <label htmlFor='driverSelect'>Driver</label>
            <select
              id='driverSelect'
              value={driverId}
              onChange={(e) => setDriverId(e.target.value)}
            >
              <option value=''>Select a driver</option>
              {availableDrivers.map(driver => (
                <option key={driver.id} value={driver.userId}>
                  {driver.name}
                </option>
              ))}
            </select>
          </div>

          <div className='form-group'>
            <label htmlFor='vehicleSelect'>Vehicle</label>
            <select
              id='vehicleSelect'
              value={vehicleId}
              onChange={(e) => setVehicleId(e.target.value)}
            >
              <option value=''>Select a vehicle</option>
              {availableVehicles.map(vehicle => (
                <option key={vehicle.id} value={vehicle.id}>
                  {vehicle.label}
                </option>
              ))}
            </select>
          </div>

          <button
            className='submit-button'
            onClick={onSubmit}
            disabled={!isValid || createScheduleAPI.loading}
          >
            {createScheduleAPI.loading ? 'Creating...' : 'Create'}
          </button>
        </div>
      </div>
    </Modal>
  );
}
